import {
  DialogContent as MuiDialogContent,
  DialogContentProps,
} from '@mui/material';
import { usePhoneLayout } from '../../hooks/usePhoneLayout';

export function DialogContent({ sx, ...props }: DialogContentProps) {
  const phone = usePhoneLayout();
  return (
    <MuiDialogContent
      {...props}
      sx={[
        { flex: 1, minHeight: 0, overflowY: 'auto', px: phone ? 2 : 3, py: 2 },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
}
